import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetTrainingsResult } from './get-trainings.result';

export async function getTrainings(): Promise<GetTrainingsResult[]> {
  const [error, res] = await tryCatch(HSApi.get<GetTrainingsResult[]>(`/trainings`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data;
}
